import React from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../context/AuthContext";

import TopNav from "../components/navigation/TopNav";
import StandardScreen, {
  ScreenContent,
} from "../components/layout/StandardScreen";
import Stack from "../components/layout/Stack";
import Card from "../components/ui/Card";
import KeyValueList from "../components/ui/KeyValueList";

const shellStyle = {
  width: "100%",
  maxWidth: "760px",
  margin: "0 auto",
};

const errorTextStyle = {
  color: "var(--color-danger)",
};

const AboutMe = () => {
  const { t } = useTranslation();
  const { user, loadingUser } = useAuth();

  if (loadingUser) {
    return (
      <StandardScreen
        topNav={<TopNav title={t("about_me.title")} mode="main" />}
        isLoading
      />
    );
  }

  if (!user) {
    return (
      <StandardScreen
        topNav={<TopNav title={t("about_me.title")} mode="main" />}
        isError
        errorState={
          <div style={errorTextStyle}>{t("about_me.errors.user_not_found")}</div>
        }
      />
    );
  }

  const allowedStatuses = ["approved", "pending", "suspended"];
  const allowed =
    user.role === "admin" ||
    allowedStatuses.includes(String(user.subscription_status || ""));

  if (!allowed) {
    return (
      <StandardScreen topNav={<TopNav title={t("about_me.title")} mode="main" />}>
        <ScreenContent>
          <div style={shellStyle}>
            <Card variant="accent">
              <strong>{t("about_me.errors.no_access")}</strong>
            </Card>
          </div>
        </ScreenContent>
      </StandardScreen>
    );
  }

  return (
    <StandardScreen topNav={<TopNav title={t("about_me.title")} mode="main" />}>
      <ScreenContent>
        <div style={shellStyle}>
          <Stack gap="5">
            <Card
              title={t("about_me.title")}
              subtitle={t("about_me.subtitle")}
            >
              <KeyValueList
                items={[
                  { label: t("about_me.fields.user_id"), value: user.user_id },
                  { label: t("about_me.fields.name"), value: user.name },
                  { label: t("about_me.fields.surname"), value: user.surname },
                  {
                    label: t("about_me.fields.phone_number"),
                    value: user.phone_number,
                  },
                  {
                    label: t("about_me.fields.role"),
                    value: user.role || "-",
                  },
                  {
                    label: t("about_me.fields.subscription_status"),
                    value: user.subscription_status || "-",
                  },
                ]}
              />
            </Card>

            {user.excursion ? (
              <Card
                title={t("about_me.excursion.title")}
                subtitle={t("about_me.excursion.subtitle")}
              >
                <KeyValueList
                  items={[
                    {
                      label: t("about_me.excursion.fields.excursion_id"),
                      value: user.excursion.excursion_id,
                    },
                    {
                      label: t("about_me.excursion.fields.name"),
                      value: user.excursion.short_name,
                    },
                    {
                      label: t("about_me.excursion.fields.about"),
                      value: user.excursion.definition || "-",
                    },
                    {
                      label: t("about_me.excursion.fields.start_date"),
                      value: user.excursion.start_date || "-",
                    },
                    {
                      label: t("about_me.excursion.fields.end_date"),
                      value: user.excursion.end_date || "-",
                    },
                    {
                      label: t("about_me.excursion.fields.currency"),
                      value: user.excursion.excursion_currency || "-",
                    },
                  ]}
                />
              </Card>
            ) : null}
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
};

export default AboutMe;